import { useEffect } from 'react'

/** Intersection Observer でスクロール時に .visible クラスを付与 */
export function useScrollAnimation() {
  useEffect(() => {
    const targets = document.querySelectorAll('.animate-on-scroll')

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible')
          }
        })
      },
      { threshold: 0.15 }
    )

    targets.forEach((el) => observer.observe(el))

    return () => observer.disconnect()
  }, [])
}
